import { useEffect, useMemo, useState } from "react";

function localDate(y, m, d, h = 0, min = 0, s = 0, ms = 0) {
  return new Date(y, m - 1, d, h, min, s, ms);
}

export default function ClosureNoticeModal() {
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);

  // 05.01.2026 - 30.01.2026 (włącznie)
  const { start, end } = useMemo(() => {
    return {
      start: localDate(2026, 1, 5, 0, 0, 0, 0),
      end: localDate(2026, 1, 30, 23, 59, 59, 999),
    };
  }, []);

  useEffect(() => {
    setMounted(true);

    const now = new Date();
    const inRange = now.getTime() >= start.getTime() && now.getTime() <= end.getTime();

    if (inRange) setOpen(true);
  }, [start, end]);

  if (!mounted || !open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="closure-title"
    >
      {/* tło */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={() => setOpen(false)}
      />

      {/* modal */}
      <div className="relative w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="bg-gradient-to-r from-indigo-700 to-indigo-500 px-6 py-5">
          <div className="flex items-start justify-between gap-4">
            <div className="text-white">
              <h2 id="closure-title" className="text-xl font-semibold tracking-wide">
                Restauracja nieczynna
              </h2>
              <p className="mt-1 text-white/90">
                Remont w terminie: <span className="font-semibold">05.01.2026 – 30.01.2026</span>
              </p>
            </div>

            <button
              onClick={() => setOpen(false)}
              className="rounded-xl bg-white/15 px-3 py-2 text-sm font-medium text-white hover:bg-white/25 focus:outline-none focus:ring-2 focus:ring-white/60"
              aria-label="Zamknij"
            >
              Zamknij ✕
            </button>
          </div>
        </div>

        <div className="px-6 py-6">
          <p className="text-slate-700 leading-relaxed">
            Informujemy, że w podanym terminie prowadzimy prace remontowe.
            Zapraszamy ponownie po zakończeniu remontu. Dziękujemy za wyrozumiałość!
          </p>

          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              onClick={() => setOpen(false)}
              className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-300"
            >
              Rozumiem
            </button>

            <a
              href="tel:+48668291465"
              className="rounded-xl bg-indigo-600 px-4 py-2 text-center text-sm font-semibold text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
            >
              Zadzwoń: 668 291 465
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
